import { render } from "./AddSomethingButton.vue?vue&type=template&id=bd0ebe4e"
import script from "./AddSomethingButton.vue?vue&type=script&lang=js"
export * from "./AddSomethingButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__